<template>
  <div id="app">
    <commonhead :active_menu="6" :callback="authcallback" />
    <div class="user_benefit my_style myorder_style">
      <div class="benefit_banner">
        <div class="topqrcode"></div>
      </div>
      <div class="content_wrap">
        <div class="data_list">
          <div class="benefit_info">
            <div class="icon-plus"></div>
            <div class="benefit_text">
              已邀请<span>{{benefitLists.length}}</span>位，共赚取<span>{{totalbonus}}元</span>
            </div>
            <div class="benefit_record">
              <div class="record_text">查看邀请记录</div>
              <div class="icon-down"></div>
            </div>
          </div>
          <Table
            :data="benefitLists"
            style="width: 100%"
            :header-cell-style="head_style"
            :cell-style="cell_style"
          >
            <TableColumn prop="created_at" label="注册时间" width="180"></TableColumn>
            <TableColumn prop="name" label="昵称" width="310"></TableColumn>
            <TableColumn prop="mobile" label="手机号" width='160'></TableColumn>
            <TableColumn prop="hasExperiencedCourse" label="体验" width='239'>
              <template slot-scope="scope">{{scope.row.hasExperiencedCourse?"已体验":"未体验"}}</template>
            </TableColumn>
            <TableColumn prop="hasPaid" label="报名" width='80'>
              <template slot-scope="scope">{{scope.row.hasPaid ? '已报名':'未报名'}}</template>
            </TableColumn>
            <TableColumn prop="bonus" label="奖励">
              <template slot-scope="scope">{{scope.row.bonus}}元</template>
            </TableColumn>
          </Table>
          <!--分页器-->
          <!-- <div class="pagination pr">
            <Pagination
              background
              @current-change="get_order"
              :page-size="10"
              layout="total, prev, pager, next"
              :total="orderData.total"
            >></Pagination>
          </div> -->
        </div>
      </div>
    </div>
    <div class="pay_model"></div>
    <!--底部信息-->
    <commonbottom />
    <!--公共底部-->
    <commonfoot />
    <!--公共底部-->
  </div>
</template>

<script>
import { common } from "../../../common.js";
import commonhead from "../common/common_head.vue";
import commonfoot from "../common/common_foot.vue";
import commonbottom from '../common/common_bottom';
import { Table, TableColumn,  Pagination } from "element-ui";
export default {
  name: "app",
  components: {
    commonhead,
    commonfoot,
    Table,
    TableColumn,
    Pagination,
    commonbottom
  },
  data: function() {
    return {
      head_style:{
        background:'rgba(28, 154, 244, 0.1)',
        color:'rgba(40,40,40,1)',
        'text-align':'center',
        'font-size': '20px',        
        'font-family': 'PingFang',
        'font-weight': '500',
        'padding': '0',
        'line-height': '50px'
      },
      cell_style:{
        color:'#666',
        'text-align':'center',
        'font-size': '16px',        
        'font-family': 'PingFang',
        'font-weight': '500',
        'padding': '20px 0',
        'line-height': '76px',
        'border-bottom-color': '#eee' 
      },
      benefitLists: [],
      totalbonus: 0
    };
  },
  mounted: function() {
    this.getbenefitLists();
  },
  methods: {
    getbenefitLists(){
      let self = this;
      common.requestFun(
        self,
        "get",
        "/student/invite/list",
        {},
        res => {
          if (res.data.code == 200) {
            self.benefitLists = res.data.data.invite_list;
            self.totalbonus = res.data.data.total_bonus;
          }else{
            self.$message({
              message: res.data.msg,
              type: "error",
              center: true,
            });
          }
        }
      );
    },
    authcallback(isLogin){
      if(!isLogin){
          this.$message({
              message: "请登录",
              type: "error",
              center: true
          });
          this.$router.push("./");
      }
    },
  }
};
</script>
<style scoped src="./index.css"></style>
